import React from 'react';
import { Helmet } from 'react-helmet';
import Header from './Header';
import Hero from './Hero';
import Intro from './Intro';
import Services from './Services';
import TestimonialsCarousel from './TestimonialsCarousel';
import CTABanner from './CTABanner';
import About from './About';
import Contact from './Contact';
import Footer from './Footer';

const HomePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Notary Public Express Service | Fast, Reliable Notary in Toronto</title>
        <meta name="description" content="Professional, reliable, and convenient notary public services in Toronto. Book your appointment today!" />
        <meta property="og:title" content="Notary Public Express Service" />
        <meta property="og:description" content="Professional, reliable, and convenient notary public services in Toronto. Book your appointment today!" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://notarypublicexpress.ca/" />
  <link rel="canonical" href="https://notarypublicexpress.ca/" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LegalService",
              "name": "Notary Public Express Service",
              "image": "https://notarypublicexpress.ca/logo512.png",
              "@id": "https://notarypublicexpress.ca/",
              "url": "https://notarypublicexpress.ca/",
              "telephone": "+1-437-449-0147",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Toronto, ON",
                "addressLocality": "Toronto",
                "addressRegion": "ON",
                "postalCode": "",
                "addressCountry": "CA"
              },
              "review": [
                {
                  "@type": "Review",
                  "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                  "author": { "@type": "Person", "name": "Su S K" },
                  "reviewBody": "Emmanuel Ibenye, Lawyer/ Notary Public, provided outstanding service today. He handled the signing of our documents with efficiency, accuracy, and professionalism. I highly recommend his services to anyone in need of reliable legal or notary assistance."
                },
                {
                  "@type": "Review",
                  "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                  "author": { "@type": "Person", "name": "Karen Hibbard" },
                  "reviewBody": "Emmanuel was understanding and accommodating to my urgent request. He is easy to work with and reasonably priced."
                },
                {
                  "@type": "Review",
                  "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                  "author": { "@type": "Person", "name": "marcus atencio" },
                  "reviewBody": "Very Professional and accommodating person. Highly recommended 👍🏽👍🏽"
                },
                {
                  "@type": "Review",
                  "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                  "author": { "@type": "Person", "name": "Fernando Fukushima" },
                  "reviewBody": "Super easy and without any complications! Truly recommend!"
                },
                {
                  "@type": "Review",
                  "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                  "author": { "@type": "Person", "name": "Tyler" },
                  "reviewBody": "Emmanuel was quick to help with my notarization and was super friendly and easy to work with! Highly recommend his services!"
                },
                {
                  "@type": "Review",
                  "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                  "author": { "@type": "Person", "name": "Ahmad Mushtaq" },
                  "reviewBody": "Awesome service, great lawyer!"
                },
                {
                  "@type": "Review",
                  "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                  "author": { "@type": "Person", "name": "Shahid Khan" },
                  "reviewBody": "Excellent and quick service at a reasonable price."
                },
                {
                  "@type": "Review",
                  "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                  "author": { "@type": "Person", "name": "Aniruddha Sawant" },
                  "reviewBody": "Emmanuel is really helpful and responds quickly. Thank you !"
                },
                {
                  "@type": "Review",
                  "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                  "author": { "@type": "Person", "name": "Joseph Youssef" },
                  "reviewBody": "The service was very quick and affordable."
                },
                {
                  "@type": "Review",
                  "reviewRating": { "@type": "Rating", "ratingValue": "5", "bestRating": "5" },
                  "author": { "@type": "Person", "name": "Kalyan Veerabhotla" },
                  "reviewBody": "I called for services in the early morning and I received immediate response. Highly recommend his services."
                }
              ]
            }
          `}
        </script>
      </Helmet>
      <Header />
      <main>
        <Hero />
        <Intro />
        <Services />
        <TestimonialsCarousel />
        <CTABanner />
        <About />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

export default HomePage;